import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tijiao",
  "use": "icon-tijiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tijiao\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64z m0 89.6a358.4 358.4 0 1 0 0 716.8A358.4 358.4 0 0 0 512 153.6z m203.968 182.208l63.36 63.36-291.2 291.2-202.88-202.88 63.36-63.36 139.52 139.52 227.84-227.84z\" p-id=\"10020\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol